/* 台账通主题切换：与工具站共用 tb-theme 存储键与 data-theme 机制 */
(function () {
  'use strict';
  var btn = document.getElementById('tz-theme');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var root = document.documentElement;
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try { localStorage.setItem('tb-theme', next); } catch (e) { /* 私密模式忽略 */ }
  });
})();
